import SingleCollectionCardSkeleton from "./single-collection-card-skeleton";

const RelatedLandingsLoading = () => {
  return (
    <div className="mx-auto fds-sm:py-16 py-8 bg-fds-canvas-primary fds-md:px-fds-120 w-full max-w-[1440px] fds-sm:px-4">
      <div className="w-full grid fds-md:grid-cols-2 grid-cols-1 gap-6 mt-6 fds-sm:mt-8">
        {Array.from({ length: 6 }).map((_, index) => (
          <SingleCollectionCardSkeleton key={index} />
        ))}
      </div>
    </div>
  );
};

export default RelatedLandingsLoading;
